import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";
import MuiTab, {TabProps} from "@material-ui/core/Tab";
import React, {FC} from "react";

const useStyles = makeStyles((theme) => ({
  tab: {
    textTransform: "capitalize",
    color: grey[800],
    fontWeight: 500,
    fontSize: theme.spacing(2),
  },
  tabSelected: {
    color: theme.palette.primary.main,
  },
  disabled: {
    pointerEvents: "none",
  },
}));

const Tab: FC<TabProps> = (props) => {
  const classes = useStyles();

  const propsClasses = props.classes;

  return (
    <MuiTab
      {...props}
      classes={{
        root: propsClasses?.root || classes.tab,
        selected: propsClasses?.selected || classes.tabSelected,
        disabled: propsClasses?.disabled || classes.disabled,
        ...(propsClasses || {}),
      }}
    />
  );
};

export default Tab;
